import {Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {ICellEditorAngularComp} from 'ag-grid-angular';
import {COMMA, ENTER} from '@angular/cdk/keycodes';
import {FormControl} from '@angular/forms';
import {Observable} from 'rxjs';
import {StorageService} from '../../../services/storage.service';
import {map, startWith} from 'rxjs/operators';
import {MatChipInputEvent} from '@angular/material/chips';
import {MatAutocompleteSelectedEvent} from '@angular/material/autocomplete';

@Component({
  selector: 'app-cell-editor-vendor-tags',
  templateUrl: './cell-editor-vendor-tags.component.html',
  styleUrls: ['./cell-editor-vendor-tags.component.scss']
})
export class CellEditorVendorTagsComponent implements ICellEditorAngularComp, OnInit {
  separatorKeysCodes: number[] = [ENTER, COMMA];
  fruitCtrl = new FormControl('');
  filteredFruits: Observable<any[]> | undefined;
  tags: any = [];
  originalTags: any = [];
  allTags: any[] = [];

  // @ts-ignore
  @ViewChild('tagInput') tagInput: ElementRef<HTMLInputElement>;
  private params: any;

  constructor(private storageService: StorageService) {
    this.allTags = storageService.vendorTags;
    this.filteredFruits = this.fruitCtrl.valueChanges.pipe(
      startWith(null),
      map((fruit: string | null) => (fruit ? this._filter(fruit) : this.allTags.slice(0, 500))),
    );
  }

  ngOnInit(): void {}

  save() {
    this.params.stopEditing();
  }

  cancel(): void {
    this.tags = this.originalTags;
    this.params.stopEditing();
  }

  agInit(params: any): void {
    this.params = params;
    console.log('params', params);
    let tagList = [];

    if (params.data.vendor_tags) {
      for (const tag of params.data?.vendor_tags) {
        const fTag = this.storageService.vendorTags.find(t => t._id === tag._id);
        if (fTag) {
          tagList.push(fTag);
        }
      }
    }

    this.tags = structuredClone(tagList);
    this.originalTags = structuredClone(tagList);
  }

  getValue(): any {
    return this.tags;
  }

  add(event: MatChipInputEvent): void {
    const value = (event.value || '').trim();

    if (value) {
      this.tags.push(value);
    }

    event.chipInput!.clear();

    this.fruitCtrl.setValue(null);
  }

  remove(tag: string): void {
    const index = this.tags.indexOf(tag);

    if (index >= 0) {
      this.tags.splice(index, 1);
    }
  }

  selected(event: MatAutocompleteSelectedEvent): void {
    this.tags.push(event.option.value);
    // @ts-ignore
    this.tagInput.nativeElement.value = '';
    this.fruitCtrl.setValue(null);
  }

  private _filter(value: any): string[] {
    const filterValue = value.name ? value.name.toLowerCase() : value.toLowerCase()
    const filtered = this.allTags.filter(tag => tag.name.toLowerCase().includes(filterValue));
    const result = [];

    for (const fTag of filtered) {
      for (const tag of this.tags) {

      }
    }
    const existTagIds = this.tags.map((tag: any) => tag._id);
    for (const fTag of filtered) {
      if (existTagIds.includes(fTag._id) === false) {
        result.push(fTag);
      }
    }

    return result.slice(0, 500);
  }

}
